<template>
  <el-dialog
      class="edit-zoho-dialog"
      title="Duplicated Cases"
      :visible.sync="dialogVisible"
      @close="closeModal"
      width="70%">
    <div v-if="hasToChooseCase">We found a duplicate case for the Examinee. Please select Add to this Case to finish the booking, or cancel to change the Examinee details.</div>
    <div v-else>Following cases may duplicated with yours, you can select to use an existing case, or modify your case details:</div>
    <el-table
        :data="result"
        style="width: 100%">
      <el-table-column
          prop="id"
          label="ID"
          width="180">
      </el-table-column>
      <el-table-column
          prop="claimantFullName"
          label="Examinee Name">
      </el-table-column>
      <el-table-column
          prop="numberBookings"
          label="Number Of Booking">
      </el-table-column>
      <el-table-column v-show="user.type > 3"
          prop="clientName"
          label="Client Name">
      </el-table-column>
      <el-table-column label="Action">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary"
              class="v-btn border-0"
              style="min-width: 0; min-height: 0;"
              @click="handleEdit(scope.$index, scope.row)">Add to this case</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <v-btn v-if="!hasToChooseCase" dark @click="handleEdit()">Make a new Case</v-btn>
       <v-btn class="white-button" dark @click="closeModal()">Cancel</v-btn>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "DuplicateCaseModal.ve",
  props: ['dialogVisible', 'result', 'hasToChooseCase'],
  data() {
    return {

    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    handleEdit(index, item) {
      this.$emit('selectCase', item)
    }
  }
}
</script>

<style scoped>

</style>
